import { Footer } from '@leagueplatform/solutions-foundation';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';
import { PatientPortalUIConfigOptions } from 'utils/patient-portal-ui-config';
import { Disclaimer } from './disclaimer-section.component';
import { useAppFooterLinks } from './use-app-footer-links.hook';

export const AppFooter = () => {
  const { footerLinks, appDownloadLinks } = useAppFooterLinks();
  const { systemId } = usePatientPortalContext();
  const { footer } = PatientPortalUIConfigOptions[systemId];

  return (
    <Footer
      backgroundColor={footer.backgroundColor}
      footerLinks={footerLinks}
      footerBody={<Disclaimer />}
      appDownloadIconLinks={
        systemId === PATIENT_PORTAL_SYSTEM_IDS.AMPLAR ? appDownloadLinks : []
      }
      layoutStyling={{
        alignItems: 'start',
      }}
    />
  );
};
